import { applyMiddleware, createStore } from 'redux';

import logger from 'redux-logger'
import thunk from 'redux-thunk';
import promise from "redux-promise";
import reducer from "./services"
import { loadAuthState, saveAuthState } from '../src/sessions/authSession';

import throttle from 'lodash/throttle';


const middleware = applyMiddleware(promise, thunk, logger)

const store = createStore(reducer, loadAuthState(), middleware);

store.subscribe(throttle(() => {
    saveAuthState({
        auth: store.getState().auth,
        baseline: store.getState().baseline,
    });
}, 1000));
export default store;